<template>
<div class="serverForm">
  <template v-if="currServs.length">
  <van-collapse v-model="activeNames" :border="false">
    <van-collapse-item name="1" :value="'查看更多'">
      <template #title>
        <h3>当前云服类型</h3>
      </template>
      <div class="currServers">
        <div v-for="(currServ, index) in currServs" class="serverItem currServer" :key="index">
          <img :src="getLevelImg(currServ.room_type)" />
          <div class="serverInfo">
            <h4>云服{{currServ.id}}</h4>
            <p>{{ROOM_TYPE[currServ.room_type]}}(最多容纳{{currServ.player_max}}人)</p>
            <p>剩余时间：{{currServ.expire_time | remainderTime}}</p>
          </div>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
  </template>
  <h3>选择云服类型</h3>
  <div class="serverList">
    <div class="serverItem" :class="{selected: selectedIndex === index, disabled: item.room_type < miniLevel}" v-for="(item, index) in price" :key="index" @click="handleServerClick(item, index)">
      <div class="serverInfo">
        <div class="serverDesc">
          <img :src="getLevelImg(item.room_type)" />
          <div class="serverInner">
            <h4>{{ROOM_TYPE[item.room_type]}}</h4>
            <p>最多容纳{{item.player_max}}人</p>
          </div>
        </div>
        <div class="serverPrice">
          <template v-if="item.sub_rmb">
            <span class="originPrice deleteLine">¥ {{item.rmb | toFixed}}</span>
            <span class="discountPrice">¥ {{item.sub_rmb | toFixed}}</span>
          </template>
          <template v-else>
            <span class="originPrice">¥ {{item.rmb | toFixed}}</span>
          </template>
        </div>
      </div>
      <div class="serverDiscount" v-if="item.sub_rmb_txt">{{item.sub_rmb_txt}}</div>
    </div>
  </div>
  <div v-show="!currServs.length">
    <h3>选择购买数量</h3>
    <van-stepper v-model="buyCount" :max="buyLimit - buyedCount" :min="min" integer></van-stepper>
  </div>
  <h3>选择时长</h3>
  <div class="btnGroupDays" size="mini">
    <van-button :class="{active: item === days}" v-for="(item, index) in day" @click="days = item" :label="item" :key="index">{{item ? item + '天' : '不延长天数'}}</van-button>
  </div>
  <div class="line"></div>
  <van-form class="order" label-position="right" label-width="92px" v-show="!hideForm">
    <van-loading size="0.5rem" text-size="0.25rem" color="#1989fa" text-color="#1989fa" vertical v-show="totalPriceLoading">更新中...</van-loading>
    <van-field label="云服类型：" label-width="1.10667rem">
      <template #input>
        <span v-if="selectedName">
        {{selectedName}}*{{buyCount}}
        </span>
        <span v-else>未选择云服</span>
      </template>
    </van-field>
    <van-field label="购买时长：" label-width="1.10667rem">
      <template #input>
        {{days}}天
      </template>
    </van-field>
    <van-field label="云服单价：" label-width="1.10667rem" v-show="isSameLevel">
      <template #input>
        {{currItem.singlePrice}}<span style="color:#FF4433;font-size:12px" v-if="currItem.singlePriceDesc">{{currItem.singlePriceDesc}}</span>
      </template>
    </van-field>
    <van-field label="费用总计：" class="total-item" label-width="1.10667rem">
      <template #input>
        <div class="total">
          ¥{{totalPrice}} <em v-show="subPrice">(已优惠¥{{subPrice}})</em>
        </div>
      </template>
    </van-field>
    <van-field label-width="2.8rem" class="lastFormItem">
      <template #label>
        <div class="serverFromFooter">
          <van-checkbox v-model="agreeProto" type="primary" icon-size="0.24rem" checked-color="#fd9b21">同意</van-checkbox>
          <a href="https://www.mini1.cn/article/20200119/1235.html" target="_blank" type="primary">《迷你云服协议》</a>
        </div>
      </template>
      <template #input>
      <van-button class="submitBtn" type="primary" @click="handleSubmit" :disabled="!agreeProto || totalPriceLoading" :loading="totalPriceLoading">提交订单</van-button>
      </template>
    </van-field>
  </van-form>
</div>
</template>
<script>
import mixins from '../../mixins/serverOrder.mixins.js'
export default {
  mixins: [mixins],
  created() {
    if (this.$route.params.type === 'renew') {
      console.log('created---', this.$route.params.currServers, this.currServs.length,this.buyLimit )
      this.buyLimit = Math.max(
        this.buyLimit,
        this.$route.params.currServers
          ? this.$route.params.currServers.length
          : this.currServs.length
      );
    }
  },
  data () {
    return {
      activeNames: ['1'],
    }
  },
  mounted(){
    //云服购买页埋点
    this.init()
  },
  methods:{
    init(){
      //云服购买页埋点
      this.$log('cloudservice_purchase_show',85438,{v7:2});
    }
  }
}
</script>
<style lang="scss" scoped>
.van-collapse{
  ::v-deep .van-collapse-item__title{
    padding: 0;
    .van-cell__value{
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #878D99;
      line-height: 36px;
    }
    .van-icon-arrow{
      font-size: 24px;
      width: 24px;
      height: 24px;
      line-height: 1;
      margin-top: 4px;
    }
  }
}
.serverForm{
  h3{
    font-size: 36px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #262626;
    line-height: 52px;
    margin-bottom: 32px;
  }
  .line{
    margin: 60px auto 30px;
    height: 2px;
    width: 660px;
    background: #d9d9d9;
  }
  .currServers{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 12px;
    .serverItem{
      width: 646px;
      height: 180px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #E1E1E1;
      margin-bottom: 16px;
      margin-right: 16px;
      display: flex;
      flex-direction: row;
      padding: 20px;
      img{
        display: block;
        width: 140px;
        height: 140px;
        margin-right: 20px;
      }
      h4{
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262626;
        line-height: 40px;
      }
      p{
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #878D99;
        line-height: 34px;
        margin-top: 8px;
      }
    }
  }
  .serverList{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 28px;
    .serverItem{
      width: 308px;
      height: 222px;
      position: relative;
      background: #FFFFFF;
      border-radius: 8px;
      border: 2px solid #E1E1E1;
      margin-right: 18px;
      margin-bottom: 20px;
      &:nth-child(2n) {
        margin-right: 0;
      }
      .serverInfo{
        .serverDesc{
          display: flex;
          flex-direction: row;
          img{
            display: block;
            width: 152px;
            height: 152px;
            padding: 16px;
          }
          .serverInner{
            display: flex;
            flex-direction: column;
            justify-content: center;
            h4{
              font-size: 28px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #262626;
              line-height: 40px;
              margin-bottom: 8px;
            }
            p{
              height: 34px;
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #878D99;
              line-height: 34px;
            }
          }
        }
      }
      .serverPrice{
        width: 280px;
        margin: 0 auto;
        padding: 16px 0;
        border-top: 2px solid #ebebeb;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: baseline;
        .originPrice{
          font-size: 20px;
          font-weight: 400;
          color: #BFBFBF;
          line-height: 28px;
          margin-right: 32px;
          &.deleteLine{
            text-decoration: line-through;
          }
        }
        .discountPrice{
          font-size: 32px;
          font-weight: 600;
          color: #FF5533;
          line-height: 44px;
        }
      }
      .serverDiscount{
        width: 84px;
        height: 36px;
        background: #FF5533;
        border-radius: 0px 8px 0px 16px;
        color: #fff;
        text-align: center;
        position: absolute;
        top: 0;
        right: 0;
      }
      &.selected{
        background: rgba(255, 204, 64, 0.06);
        border: 1px solid #FFCC40;
      }
      &.disabled{
        opacity: 0.6;
        .serverInfo{
          .serverDesc{
            img{
              filter: grayscale(1);
            }
          }
        }
        .serverDiscount{
          background: linear-gradient(90deg, #EBEBEB 0%, #CCCCCC 100%);
        }
      }
    }
  }
  .van-stepper{
    margin-bottom: 44px;
    ::v-deep .van-stepper__minus{
      width: 64px;
      height: 64px;
      background: #FFFFFF;
      border: 2px solid #E1E1E1;
    }
    ::v-deep .van-stepper__plus{
      width: 64px;
      height: 64px;
      background: #FFFFFF;
      border: 2px solid #E1E1E1;
    }
    ::v-deep .van-stepper__input{
      background: #FFFFFF;
      border: 2px solid #E1E1E1;
      margin: 0;
      border-left: 0;
      border-right: 0;
      width: 112px;
      height: 64px;
    }
  }
  ::v-deep .van-stepper__input{
    font-size: 28px;
    line-height: 34px;
  }
  .btnGroupDays{
    .van-button{
      height: 64px;
      background: #FFFFFF;
      border-radius: 7px;
      border: 2px solid #E1E1E1;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #323232;
      padding: 0 32px;
      margin-right: 16px;
      margin-bottom: 16px;
      &.active{
        background-color: #FFF9EB;
        border-color: #FFCC40;
      }
    }
  }
  .order{
    height: auto;
    overflow: hidden;
    background: #fff;
    margin-bottom: 20px;
    position: relative;
    .van-field{
      padding: 0;
      font-size: 32px;
      height: auto;
      line-height: 56px;
      ::v-deep .van-cell__title {
        width: 166px;
      }
      ::v-deep .van-cell__title.van-field__label{
        margin-right: 3px;
      }
      ::v-deep .van-field__control{
        flex-wrap: wrap;
      }
      &::after{
        display: none;
      }
      &.total-item{
        margin-top: 16px;
        ::v-deep .van-cell__value{
          font-size: 36px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          line-height: 56px;
          .total{
            color: #FF4433;
            em{
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #FF5533;
              line-height: 52px;
              font-style: normal;
            }
          }
        }
      }
      &.lastFormItem{
        min-height: 72px;
        margin-top: 32px;
        ::v-deep .van-cell__title{
          display: flex;
          align-items: center;
        }
        ::v-deep .van-cell__value{
          min-height: 72px;
          .van-field__control {
            justify-content: flex-end;
          }
        }
      }
    }
  }
  .serverFromFooter{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    a{
      height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3B9BFF;
      line-height: 44px;
    }
  }
  .submitBtn{
    width: 208px;
    height: 72px;
    background: #FECB4E;
    border-color: #FECB4E;
    border-radius: 16px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3D3C3C;
    line-height: 40px;
  }
}
.van-loading--vertical{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: rgba(255,255,255,0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
